import {Component, OnInit, OnDestroy} from '@angular/core';
import {ApiService} from '../../../services/api.service';
import {Chart} from 'chart.js';
import {HttpParams} from '@angular/common/http';
import * as _ from 'lodash';
import {SubSink} from 'subsink';
import {SelectItem} from "primeng/api";

@Component({
  selector: 'app-billing-list',
  templateUrl: './billing-list.component.html',
  styleUrls: ['./billing-list.component.scss']
})
export class BillingListComponent implements OnInit, OnDestroy {
  itemsPerPage = 10;

  monthListDropdown = [
    {label: 'มกราคม', value: 1},
    {label: 'กุมภาพันธ์', value: 2},
    {label: 'มีนาคม', value: 3},
    {label: 'เมษายน', value: 4},
    {label: 'พฤษภาคม', value: 5},
    {label: 'มิถุนายน', value: 6},
    {label: 'กรกฎาคม', value: 7},
    {label: 'สิงหาคม', value: 8},
    {label: 'กันยายน', value: 9},
    {label: 'ตุลาคม', value: 10},
    {label: 'พฤศจิกายน', value: 11},
    {label: 'ธันวาคม', value: 12}
  ];
  yearList: any[] = [];
  selectedCompany: SelectItem[];
  company: any;
  list: any = [];
  selectedMonth: any;
  selectedYear: any;
  totalItems: number;
  currentPage = 1;
  loading = false;
  title = '';
  selectedDuplictedData = false;
  includeInB2POnly = false;
  loading_excel_report = false;

  private subs = new SubSink();

  constructor(private apiService: ApiService) {
  }

  ngOnInit() {
    this.populateDropdown();
    this.loadData();
  }

  populateDropdown() {
    const currentDate = new Date();
    // populate year list back within 10 years
    const thisYear = currentDate.getFullYear();
    for (let i = 0; i <= 10; i++) {
      this.yearList.push({label: (thisYear - i).toString(), value: thisYear - i});
    }

    // set current month and year
    this.selectedMonth = currentDate.getMonth() + 1;
    this.selectedYear = thisYear;

    this.company = [
      {
        label: 'ทั้งหมด',
        value: null
      }
    ];

    this.subs.add(
      this.apiService.getCompany().subscribe(result => {
        _.forEach(result, obj => {
          this.company.push({
            label: obj.name + ' / ' + obj.tax_id,
            value: obj.tax_id
          });
        });
      })
    );
  }

  // search() {
  //   if (this.currentPage != 1) {
  //     this.currentPage = 1;
  //     this.pageChanged();
  //   }
  //   else {
  //     this.pageChanged();
  //   }
  // }

  pageChanged() {
    const params = new HttpParams().set('page', _.toString(this.currentPage));
    this.loadData(params);
  }

  search() {
    this.currentPage = 1;
    this.loadData();
  }

  loadData(params?) {
    const data = {
      month: this.selectedMonth,
      year: this.selectedYear,
      duplicate_only: this.selectedDuplictedData,
      included_in_b2p_only: this.includeInB2POnly
    };

    if (this.selectedCompany) {
      data['seller_tax_id'] = this.selectedCompany;
    }

    this.title = '';
    this.loading = true;
    this.subs.add(
      this.apiService.sign_counter(data, params).subscribe((res: any) => {
        this.list = res.results;
        this.totalItems = res.count;
        // this.title = "พบการลงลายมือชื่อดิจิทัลทั้งหมด " + this.totalItems.toLocaleString() + " ครั้ง";
        this.loading = false;
      })
    );
  }

  clearSearch() {
    const currentDate = new Date();

    // set current month and year
    this.selectedMonth = currentDate.getMonth() + 1;
    this.selectedYear = currentDate.getFullYear();
    this.selectedDuplictedData = false;
    this.selectedCompany = null;

    this.search();
  }

  humanFileSize(size) {
    const i = Math.floor(Math.log(size) / Math.log(1024));
    return (size / Math.pow(1024, i)).toFixed(0) + ' ' + ['B', 'KB', 'MB', 'GB', 'TB'][i];
  }

  DownloadExcelReport() {
    this.loading_excel_report = true;

    const params = {
      month: this.selectedMonth,
      year: this.selectedYear,
      duplicate_only: this.selectedDuplictedData,
      included_in_b2p_only: this.includeInB2POnly
    };
    if (this.selectedCompany) {
      params['seller_tax_id'] = this.selectedCompany;
    }
    this.subs.add(
      this.apiService.getBillingExcelReport(params).subscribe(
        obj => {
          const filename =
            'billing_report_' + this.selectedMonth + '_' + this.selectedYear + '.csv';
          this.apiService.createDownloadFile(obj, filename);
          this.loading_excel_report = false;
          this.sniff('DOWNLOAD_EXCEL', filename);
        },
        error => {
          this.loading_excel_report = false;
        }
      )
    );
  }

  sniff(action, detail) {
    const data = {
      action: action,
      feature: 'BILLING',  // TODO: *Billing อยู่หน้าไหนหรอ (การเรียกเก็บเงิน)
      detail: detail
    };
    this.apiService.sniff(data).subscribe(
      (res: any) => {
      },
    );
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}



// WEBPACK FOOTER //
// /opt/app/src/app/features/billing/billing-list/billing-list.component.ts